import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

import { StatusSistemaAtendimentoComponent } from './status-sistema-atendimento.component';

@NgModule({
  declarations: [StatusSistemaAtendimentoComponent],
  imports: [CommonModule, MatTooltipModule],
  exports: [StatusSistemaAtendimentoComponent],
})
export class StatusSistemaAtendimentoModule {}
